import { createContext } from 'react';

/** Which map library PlaceMap renders: Leaflet on the website, MapLibre inside the mobile shell. */
export const MapEngineContext = createContext<'leaflet' | 'gl'>('leaflet');
